import { useState } from "react";

function useImageSlide() {
  const [openSlide, setOpenSlide] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);

  const handleOpenSlide = (index) => {
    setSelectedImage(index);
    setOpenSlide(true);
  };

  const handleCloseSlide = () => {
    setOpenSlide(false);
  };

  return { openSlide, selectedImage, handleOpenSlide, handleCloseSlide };
}

export default useImageSlide;
